/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Access_Tokens_UnavailableInputs */

const en_error_access_tokens_unavailable = /** @type {(inputs: Error_Access_Tokens_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access tokens are not available in this environment yet.`)
};

/**
* | output |
* | --- |
* | "Access tokens are not available in this environment yet." |
*
* @param {Error_Access_Tokens_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_access_tokens_unavailable = /** @type {((inputs?: Error_Access_Tokens_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Access_Tokens_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_access_tokens_unavailable(inputs)
});